import store from "./store.js";

export async function getAllPrinters() {
    store.setLoading(0, true);
    store.setLoading(1, true);
    store.setLoading(2, true);

    return fetch("/api/v1/products/compare/products")
        .then((response) => response.json())
        .then((data) => store.setPrinters(data || []))
        .finally(() => {
            store.setLoading(0, false);
            store.setLoading(1, false);
            store.setLoading(2, false);
        });
}

export async function getPrinter(model_number, slotIndex) {
    store.setLoading(slotIndex, true);
    store.addSelectedPrinter(slotIndex, null);
    return fetch(`/api/v1/products/compare/product?model_number=${model_number}`)
        .then((response) => response.json())
        .then((data) => store.addSelectedPrinter(slotIndex, data))
        .finally(() => {
            store.setLoading(slotIndex, false);
        });
}
